import React from 'react';
import classNames from 'classnames';
import './index.scss';

export interface PurpleLogoProps {}

const PurpleLogo = ({}: PurpleLogoProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const cx = classNames.bind('./index.scss');

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('PurpleLogo')}>
      <img src="/assets/images/logo.png" alt="logo" className={cx('PurpleLogo')} />
    </div>
  );
};

export default PurpleLogo;
